/**
 * For some reason we have to provide this string to some Users Auth API
 * endpoints. The users team is considering to remove this redundant parameter
 * as it does not bring much security.
 */
export const USERS_AUTH_API_CLIENT_SECRET =
  "0bd30923dd0b5041ebd11d7f33d25f22df164d7efea106d8c0ac37b19e9d302d";
